module.exports = __webpack_public_path__ + "media/assets/images/category/Sports@2x-7b581652c9d9e976d7bc80d04b27052c.png";